var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.664,
    height: 69.723,
    viewBox: "0 0 132.664 69.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1",
    "data-name": "Vector 1",
    d: "M12.58,63.826,61.5,3.551a7.282,7.282,0,0,1,11.45.147C90.008,26.026,116.211,60.967,118.1,63.376c3.465,4.428,6.353,7.176,14.567,7.188L1.154,70.374q-.56.019-1.154,0l1.154,0C7.5,70.157,10.64,66.19,12.58,63.826Z",
    transform: "translate(0 -0.842)",
    fill: "#fde4e5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionTriangle);
export default __webpack_public_path__ + "static/media/action_triangle.27a811df983e77d9179384a0aa1e3fb0.svg";
export { ForwardRef as ReactComponent };